module.exports = __webpack_public_path__ + "img/guide-andorid@3x.566fe3b8.jpg";